import { Utils } from 'formiojs';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormioLoader } from 'dp-formio';

@Component({
    selector: 'extra-form-dialog',
    templateUrl: 'extra-form-dialog.component.html',
    styleUrls: ['./extra-form-dialog.component.scss'],
    providers: [FormioLoader]
})
export class ExtraFormDialog implements OnInit {
    formControls: FormGroup = new FormGroup({});

    constructor(
        public dialogRef: MatDialogRef<ExtraFormDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private loader: FormioLoader) {

        if (this.data.addToSubFormSubmission)
            this.data.submission = Utils.evaluate(this.data.addToSubFormSubmission,
                { data: this.data.submission.data, submission: this.data.submission },
                'submission');
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    ngOnInit(): void {
        this.loader.loading = false;
    }

    onCustomEvent(event: any) {
        console.log(event);
        if (event.component.key == 'cancel') this.onNoClick();
        else if (event.component.key == 'submit') {
            if (this.data.updateBaseFormSubmission) {
                this.data.submission = Utils.evaluate(this.data.updateBaseFormSubmission,
                    { data: event.data, submission: this.data.submission },
                    'submission');
                this.dialogRef.close(this.data.submission);
            } else this.dialogRef.close(this.data.submission);
        }
    }

    onSubmit(event: any) {
        if (!this.data.updateBaseFormSubmission)
            this.dialogRef.close(this.data.submission);
    }

}
